/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=bf411fd2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=bf411fd2&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-案例中心-前台页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf411fd2"]])

export default __exports__